module.exports = "<a class=\"waves-effect btn-flat btn-floating blue darken-1 tooltipped\" data-position=\"bottom\" data-delay=\"50\" data-tooltip=\"Back\" (click)=\"backToSearch()\"><i class=\"material-icons left\">arrow_back</i></a>"


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/inAppBack/back-button/back-button.component.html
// module id = ../../../../../src/app/shared/inAppBack/back-button/back-button.component.html
// module chunks = main